
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  const boardMembers = [
    {
      name: '王建煊',
      position: '理事長',
      background: '前監察院院長、財政部部長',
      image: 'https://public.readdy.ai/ai/img_res/46823826c55aa43b4602795e12c88e00.jpg'
    },
    {
      name: '劉憶如',
      position: '副理事長',
      background: '前經濟部部長、中央銀行副總裁',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20middle-aged%20Chinese%20woman%20in%20business%20attire%2C%20confident%20expression%2C%20government%20official%20style%2C%20warm%20lighting%2C%20traditional%20background&width=300&height=400&seq=vicechairman&orientation=portrait'
    },
    {
      name: '許璋瑤',
      position: '常務理事',
      background: '台灣大學經濟系教授',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20academic%20professor%20in%20formal%20attire%2C%20scholarly%20appearance%2C%20university%20setting%20background%2C%20warm%20lighting&width=300&height=400&seq=director1&orientation=portrait'
    },
    {
      name: '黃天麟',
      position: '常務理事',
      background: '前第一銀行董事長',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20senior%20Chinese%20businessman%20in%20formal%20suit%2C%20banking%20executive%20style%2C%20corporate%20background%2C%20warm%20lighting&width=300&height=400&seq=director2&orientation=portrait'
    },
    {
      name: '陳冲',
      position: '理事',
      background: '前行政院院長、金管會主委',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20government%20official%20in%20formal%20business%20suit%2C%20executive%20appearance%2C%20traditional%20office%20background%2C%20warm%20lighting&width=300&height=400&seq=director3&orientation=portrait'
    },
    {
      name: '薛琦',
      position: '理事',
      background: '東吳大學講座教授',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20academic%20professor%20in%20formal%20attire%2C%20distinguished%20appearance%2C%20university%20library%20background%2C%20warm%20lighting&width=300&height=400&seq=director4&orientation=portrait'
    }
  ];

  const organizationInfo = {
    establishment: '2019年11月14日',
    purpose: '紀念嚴前總統家淦先生對國家的貢獻，傳承其治國理念與文化精神',
    mission: '中庸治世．科技立國．文化永續',
    address: '台北市大安區新生南路三段30號',
    phone: '(02) 2362-0123',
    email: 'info@ckyen.org.tw'
  };

  const achievements = [
    {
      year: '2019',
      title: '協會成立',
      description: '正式成立嚴前總統家淦先生紀念協會',
      icon: 'ri-flag-line'
    },
    {
      year: '2020',
      title: '故居修復啟動',
      description: '開始進行自由之家與大同官邸的修復工程',
      icon: 'ri-building-line'
    },
    {
      year: '2021',
      title: '文物典藏',
      description: '建立完整的文物典藏與數位化系統',
      icon: 'ri-archive-line'
    },
    {
      year: '2022',
      title: '教育推廣',
      description: '與各大學合作推動歷史教育與研究',
      icon: 'ri-graduation-cap-line'
    },
    {
      year: '2023',
      title: '國際交流',
      description: '舉辦國際學術研討會，促進文化交流',
      icon: 'ri-global-line'
    },
    {
      year: '2024',
      title: '數位展覽',
      description: '推出線上虛擬展覽與AI互動系統',
      icon: 'ri-computer-line'
    }
  ];

  return (
    <div className="min-h-screen bg-stone-50">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-amber-50 to-stone-100">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-5xl font-bold text-stone-800 mb-6">
              嚴前總統家淦先生紀念協會
            </h1>
            <p className="text-2xl text-amber-600 font-semibold mb-8">
              {organizationInfo.mission}
            </p>
            <p className="text-xl text-stone-600 leading-relaxed">
              {organizationInfo.purpose}
            </p>
          </div>
        </div>
      </section>

      {/* Organization Overview */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold text-stone-800 text-center mb-16">協會簡介</h2>
            
            <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
              <div>
                <h3 className="text-3xl font-bold text-stone-800 mb-6">成立宗旨</h3>
                <p className="text-lg text-stone-600 leading-relaxed mb-6">
                  嚴前總統家淦先生紀念協會成立於2019年，旨在紀念嚴家淦總統對中華民國的卓越貢獻，
                  傳承其「中庸治世、科技立國、文化永續」的治國理念。
                </p>
                <p className="text-lg text-stone-600 leading-relaxed mb-6">
                  協會致力於保存與推廣嚴總統的歷史文物，透過教育、研究與文化活動，
                  讓更多人了解這位「新台幣之父」對台灣經濟奇蹟的重要貢獻。
                </p>
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-white p-6 rounded-xl shadow-lg">
                    <div className="text-amber-600 mb-3">
                      <i className="ri-calendar-line text-2xl"></i>
                    </div>
                    <h4 className="font-semibold text-stone-800 mb-2">成立日期</h4>
                    <p className="text-stone-600">{organizationInfo.establishment}</p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-lg">
                    <div className="text-amber-600 mb-3">
                      <i className="ri-team-line text-2xl"></i>
                    </div>
                    <h4 className="font-semibold text-stone-800 mb-2">組織性質</h4>
                    <p className="text-stone-600">非營利文化教育機構</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-2xl p-8 shadow-xl">
                <h3 className="text-2xl font-bold text-stone-800 mb-6 text-center">聯絡資訊</h3>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-map-pin-line text-amber-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-stone-800">地址</h4>
                      <p className="text-stone-600">{organizationInfo.address}</p>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-phone-line text-amber-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-stone-800">電話</h4>
                      <p className="text-stone-600">{organizationInfo.phone}</p>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-mail-line text-amber-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-stone-800">電子郵件</h4>
                      <p className="text-stone-600">{organizationInfo.email}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Board Members */}
      <section className="py-20 bg-stone-100">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold text-stone-800 text-center mb-16">理事會成員</h2>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {boardMembers.map((member, index) => (
                <div key={index} className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-shadow duration-300">
                  <div className="w-32 h-40 mx-auto mb-6 rounded-xl overflow-hidden">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-2xl font-bold text-stone-800 mb-2">{member.name}</h3>
                  <p className="text-amber-600 font-semibold mb-3">{member.position}</p>
                  <p className="text-stone-600 text-sm leading-relaxed">{member.background}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Achievements Timeline */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-stone-800 text-center mb-16">重要里程碑</h2>
            
            <div className="relative">
              {/* Timeline Line */}
              <div className="absolute left-8 top-0 bottom-0 w-1 bg-amber-200"></div>
              
              <div className="space-y-12">
                {achievements.map((achievement, index) => (
                  <div key={index} className="relative flex items-start">
                    {/* Timeline Node */}
                    <div className="flex-shrink-0 w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg z-10">
                      {achievement.year}
                    </div>
                    
                    {/* Content */}
                    <div className="ml-8 bg-white rounded-2xl p-8 shadow-lg flex-grow">
                      <div className="flex items-start">
                        <div className="flex-shrink-0 w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-6">
                          <i className={`${achievement.icon} text-amber-600 text-xl`}></i>
                        </div>
                        <div>
                          <h3 className="text-2xl font-bold text-stone-800 mb-3">{achievement.title}</h3>
                          <p className="text-stone-600 leading-relaxed">{achievement.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-gradient-to-br from-amber-50 to-stone-100">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold text-stone-800 text-center mb-16">使命與願景</h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
                <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-heart-line text-3xl text-amber-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-stone-800 mb-4">中庸治世</h3>
                <p className="text-stone-600 leading-relaxed">
                  傳承嚴總統中庸之道的治國理念，推動和諧穩定的社會發展
                </p>
              </div>
              
              <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
                <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-rocket-line text-3xl text-amber-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-stone-800 mb-4">科技立國</h3>
                <p className="text-stone-600 leading-relaxed">
                  延續嚴總統重視科技發展的遠見，促進創新科技的應用與發展
                </p>
              </div>
              
              <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
                <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-leaf-line text-3xl text-amber-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-stone-800 mb-4">文化永續</h3>
                <p className="text-stone-600 leading-relaxed">
                  保存與傳承中華文化精髓，推動文化教育的永續發展
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
